import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import 'rxjs';
import 'rxjs/Rx';

@Injectable()
export class SigninSignupService {
  AUTH_URL: string = '';
  environmentName: string = '';
  JLL_DOMAIN: string = '';
  featureObject: any = {};

  constructor(public router: Router, public http: HttpClient) {
  }

  getHeaders() {
    let headers = { 'Content-Type': 'application/json' };
    return headers;
  }

  getVerificationCode(userWithPhoneNumber) {
    const headers = this.getHeaders();

    return this.http
      .post(this.AUTH_URL + '/get-code', userWithPhoneNumber, { headers })
      .map(res => {
        return res;
      });
  }

  signUpUser(user) {
    let headers = this.getHeaders(),
    w = <any>window,
    requestPath = this.AUTH_URL + '/register?source=' + this.getApplicationSourceName();
    if (!w.isApplicationMarketplace() && this.requiresDomainCookieRedirect()) {
      requestPath = w.apiUrlFormatter.addQueryParamToUrl(
        requestPath,
        'path',
        this.getLoginRedirectPath()
      );
    }
    return this.http
      .post(requestPath, user, { headers })
      .map((res: any) => {
        return res;
      });
  }

  getApplicationSourceName() {
    let w = <any>window;
    if(w.isApplicationMarketplace()) {
      return 'marketplace'
    } else if(w.isApplicationMaps()) {
      return 'maps'
    } else {
      return 'tourbooks';
    }
  }

  login(user, rememberMe: boolean) {
    let headers = this.getHeaders(),
    w = <any>window,
    userLoginRequest = {
      emailAddress: user.emailAddress,
      password: user.password
    },
    requestPath = this.AUTH_URL + '/login?source=' + this.getApplicationSourceName();
    if (!w.isApplicationMarketplace() && this.requiresDomainCookieRedirect()) {
      requestPath = w.apiUrlFormatter.addQueryParamToUrl(
        requestPath,
        'path',
        this.getLoginRedirectPath()
      );
    }
    return this.http
      .post(requestPath, JSON.stringify(userLoginRequest), {
        headers
      })
      .map(res => {
        return res;
      });
  }

  requiresDomainCookieRedirect() {
    return this.isJLLSite() && (this.isSafari() || this.isChrome());
  }

  isJLLSite() {
    return (<any>window).location.hostname === this.JLL_DOMAIN;
  }

  isSafari() {
    let isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    return isSafari;
  }

  isChrome() {
    let isChrome = !!navigator.userAgent.match(/CriOS/);
    return isChrome;
  }

  focusFirstEmptyElement(elementClass) {
    let inputVal: any = <HTMLElement>(
      (<any>document.getElementsByClassName(elementClass))
    );
    if (inputVal) {
      for (let i = 0; i < inputVal.length; i++) {
        if (!inputVal[i].value || inputVal.length === 1) {
          inputVal[i].focus();
          return false;
        }
      }
    }
  }

  isEnterKeyHit(event) {
    return event && event.keyCode === 13;
  }

  isTabKeyHit(event) {
    return event && event.keyCode === 9;
  }

  stopProp(e) {
    e.stopPropagation();
  }

  onLinkedInButtonClick() {
    let w = <any>window;
    if(!this.isJLLSite()) {
      (<any>window).Events.publish('saveFeatureExecutionData', () => {
        this.goToLinkedInPage();
      });
    }
  }

  getLinkedInUrl() {
    let w = <any>window,
      linkedInUrl = this.AUTH_URL + '/sso/social/linkedin/login?source=' + this.getApplicationSourceName();
    linkedInUrl = w.apiUrlFormatter.addQueryParamToUrl(
      linkedInUrl,
      'path',
      this.getLoginRedirectPath()
    );
    return linkedInUrl;
  }

  getLinkedInQueryParam(url) {
    if (url.includes('log-in')) {
      return 'login';
    } else if (url.includes('sign-up')) {
      return 'signup';
    } else {
      return null;
    }
  }

  getLoginRedirectPath() {
    let w = <any>window,
      redirectUrl = w.location.href;
    if(!this.requiresDomainCookieRedirect()) {
      redirectUrl = w.apiUrlFormatter.addQueryParamToUrl(
      redirectUrl,
      'fromLinkedIn',
      this.getLinkedInQueryParam(redirectUrl)
      );
      redirectUrl = w.apiUrlFormatter.addQueryParamToUrl(
        redirectUrl,
        'featureToExecute',
        JSON.stringify(this.featureObject)
      );
    } else {
      redirectUrl = w.apiUrlFormatter.addQueryParamToUrl(
        redirectUrl,
        'redirectedFrom',
        this.getLinkedInQueryParam(redirectUrl)
      );
    }
    redirectUrl = redirectUrl.replace('/log-in', '');
    redirectUrl = redirectUrl.replace('/sign-up', '');
    redirectUrl = redirectUrl.replace('open', '');
    return redirectUrl;
  }

  goToLinkedInPage() {
    let link = document.createElement('a');
    let href = this.getLinkedInUrl();
    link.href = href;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/signin-signup/signin-signup.service.ts